import { Box, Container } from '@amzn/awsui-components-react';
import { useContext } from 'react';

import { constants } from '../../common/Localization';
import { TcoContext } from '../../contexts/TcoContext';

interface Props {
    hideMigrationCostText: boolean;
}

function TcoFooter({ hideMigrationCostText }: Props): JSX.Element {
    const { assessment } = useContext(TcoContext);

    const getLegalMessage = (): string => {
        let legalMessage = constants.DEFAULT_LEGAL_MESSAGE;
        const { relocateOn } =  assessment?.configuration.tcoAssumptions ?? {};
        const { enableRDSRightSize } = assessment?.configuration.awsRDSRightSize ?? {};
        const { includeDBLicenseInTCO } = assessment?.configuration.databaseLicense ?? {};
        if (relocateOn && enableRDSRightSize) {
            legalMessage = constants.LEGAL_MESSAGE_WITH_RDS_AND_RELOCATE;
        } else if (relocateOn) {
            legalMessage = constants.LEGAL_MESSAGE_WITH_RELOCATE;
        } else if (enableRDSRightSize) {
            legalMessage = constants.LEGAL_MESSAGE_WITH_RDS;
        }
        if ( enableRDSRightSize && includeDBLicenseInTCO ) {
            legalMessage = `${legalMessage} ${constants.LEGAL_MESSAGE_DB_LICENSE}`;
        }
        return legalMessage;
    };

    return (
        <Container disableHeaderPaddings disableContentPaddings>
            <Box padding={{horizontal: 'xl'}}>
                <p><sup>*</sup>&nbsp;{getLegalMessage()}</p>
                {!hideMigrationCostText && <p><sup>**</sup>&nbsp;{constants.DOES_NOT_INCLUDE_MIGRATION_COST}</p>}
            </Box>
        </Container>
    );
}

export default TcoFooter;
